import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
 
  //import {BranchElement} from "../../Models/ApplicationModels/BranchModel";
 //import {ItemMasterBasic2_VariationElement} from "../../Models/ApplicationModels/ItemMasterBasic2_VariationModel";

 //import { environment } from '../../../environments/environment';
//   private apiUrl = environment.apiUrl;

import { environment } from '../../environments/environment';


@Injectable()
export class ItemMasterBasic2_VariationService {

    ////import { environment } from '../../../environments/environment';
    private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /////////////////////////  ------------  GET ALL ------------


  getAllItemBasic2Variation() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2Variation",httpOptions);
  }


  ///////////////////////  ----------- GET ALL BY ID -----------

  
  getAllItemBasic2VariationByItemProductTypeId( id:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
  return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2VariationByItemProductTypeId?ItemProductTypeId="+id,httpOptions);
  //  GetAllItemMasterBasic2_VariationInfoByItemProductTypeId
  
  }
   
  getAllItemBasic2VariationByItemProductTypeMainId( id:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2VariationByItemProductTypeMainId?ItemProductTypeMainId="+id,httpOptions);
  }



  getAllItemBasic2VariationByItemId( itemid:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2VariationByItemId?itemid="+itemid,httpOptions);
  }

  getAllItemBasic2VariationByItemIdCount( itemid:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2VariationByItemIdCount?itemid="+itemid,httpOptions);
  }

  getAllItemBasic2VariationByVariationId( itemvariationid:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ItemBasic2_Variation/GetAllItemBasic2VariationByVariationId?itemvariationid="+itemvariationid,httpOptions);
  }



  /////////////////////////////  ------------- CURD -----------------



}
